import { useCallback } from 'react'
import { useSelector } from 'react-redux'

/**
 * Interpolates a string with values from a params object.
 * Replaces {{key}} placeholders with corresponding values.
 * @param {string} str - The string containing placeholders
 * @param {Object} params - Object with key-value pairs for interpolation
 * @returns {string} - The interpolated string
 */
const interpolate = (str, params) => {
  if (!params || typeof str !== 'string') return str
  return str.replace(/\{\{(\w+)\}\}/g, (_, key) => {
    return params[key] !== undefined ? params[key] : `{{${key}}}`
  })
}

const useTranslation = () => {
  const { locale, dictionary } = useSelector(state => state.i18nL10n)

  return useCallback(
    (key, defaultValue, params) => {
      let result
      if (!dictionary || !dictionary[locale] || !dictionary[locale][key]) {
        result = defaultValue || key
      } else {
        result = dictionary[locale][key]
      }
      return interpolate(result, params)
    },
    [dictionary, locale]
  )
}

export const useTranslateInLocale = () => {
  const dictionary = useSelector(state => state.i18nL10n.dictionary)
  return (key, targetLocale, defaultValue) => {
    if (dictionary && dictionary[targetLocale] && dictionary[targetLocale][key]) {
      return dictionary[targetLocale][key]
    }
    return defaultValue || key
  }
}

export default useTranslation
